import { useState } from 'react';
import { LayoutModule } from '../../../layout/modules';
import { RedirectAreaFilters } from './filters';
import { RedirectAreaList } from './list';
import { REDIRECT_AREA, REDIRECT_AREA_NEW } from '../../../../routes/paths';
import ActionButtonGroup from '../../../components/general/buttons/actionButtonGroup';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../redux/store';
import {
    isOnlyViewProfile,
    isOperativeProfile,
} from '../../../../shared/types/profiles';
import { Param } from '../../../../shared/types/param';

export const RedirectArea = () => {
    const [filters, setFilters] = useState<Param>();

    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};
    return (
        <>
            <LayoutModule
                title="Búsqueda de áreas redirección PQR"
                showTitle
                additionalButtons={
                    <ActionButtonGroup
                        buttonCreate={{
                            show:
                                !isOnlyViewProfile(type) &&
                                !isOperativeProfile(type),
                            route: REDIRECT_AREA_NEW,
                        }}
                        buttonSearch={{
                            show: true,
                            route: REDIRECT_AREA,
                        }}
                    />
                }
            >
                <RedirectAreaFilters
                    onFilter={(filters) => setFilters(filters)}
                />
            </LayoutModule>
            <RedirectAreaList filters={filters} />
        </>
    );
};
